import React from 'react'

const Terms = () => {
  return (
    <div className='my-6'>
        {/* 利用規約 */}
        <h2 className='text-2xl text-center mb-6'>利用規約</h2>

        <div className='max-w-2xl mx-auto'>
            <p>本Webアプリ「電鬼2」（以下「本アプリ」といいます）をご利用いただくにあたり、以下の利用規約（以下「本規約」といいます）をお読みいただき、同意いただいた上でご利用ください。</p>
            <p>本アプリを利用するユーザー（以下「ユーザー」といいます）は、本規約に同意したものとみなします。</p>
            <p>当事務局は、本規約を変更することがあります。変更後の規約は、本アプリに掲載した時点で効力を生じるものとします。</p>
            <p>なお、本規約は、本アプリにおいてのみ適用され、本アプリ以外のウェブサイトやアプリケーションへのリンクは、本規約の適用外となります。</p>

            <h3 className='text-xl mt-6 text-purple-800'>1. 禁止事項</h3>
            <p>ユーザーは、本アプリの利用にあたり、以下の行為を行ってはなりません。</p>
            <ul className='list-disc list-inside'>
                <li>法令または公序良俗に違反する行為</li>
                <li>当事務局または第三者の権利を侵害する行為</li>
                <li>虚偽の情報を提供する行為</li>
                <li>本アプリの運営を妨害する行為</li>
                <li>その他、当事務局が不適切と判断する行為</li>
            </ul>

            <h3 className='text-xl mt-6 text-purple-800'>2. 免責事項</h3>
            <p>当事務局は、本アプリの利用により生じた損害について、一切の責任を負いません。</p>
            <p>本アプリは、予告なしに変更・中断・終了することがあります。</p>

            <h3 className='text-xl mt-6 text-purple-800'>3. 著作権</h3>
            <p>本アプリに掲載されているコンテンツの著作権およびユーザーにより作成されたゲームデータは、当事務局に帰属します。</p>
            <p>無断での転載・複製・改変等は禁止します。</p>

            <h3 className='text-xl mt-6 text-purple-800'>4. お問い合わせ</h3>
            <p>本規約に関するお問い合わせは、以下のメールアドレスまでご連絡ください。</p>
            <p>メールアドレス：metrotagcomittee@gmail.com</p>

            <p className='text-end my-3'>2024年12月1日制定</p>
        </div>
    </div>
  )
}

export default Terms